import { MessageNotificationCard } from '../molecules/message-notification-card';
import type { MessageNotificationAlertsProps } from '../../types/notification-presentation.types';

/** Responsive message alerts that stay available while their actions are being used. */
export const MessageNotificationAlerts = ({
  alerts,
  onOpen,
  onDismiss,
  onPause,
}: MessageNotificationAlertsProps) => (
  <div
    className="pointer-events-none fixed inset-x-3 top-[calc(env(safe-area-inset-top)+1rem)] z-50 flex flex-col gap-2 sm:inset-x-auto sm:right-5 sm:top-5 sm:w-96"
    aria-live="polite"
    aria-relevant="additions text"
  >
    {alerts.map((group) => (
      <div
        key={group.key}
        className="pointer-events-auto hidden last:block sm:block"
        onMouseEnter={() => onPause(group.key, true)}
        onMouseLeave={(event) => {
          if (!event.currentTarget.contains(document.activeElement)) {
            onPause(group.key, false);
          }
        }}
        onFocus={() => onPause(group.key, true)}
        onBlur={(event) => {
          if (
            !event.currentTarget.contains(event.relatedTarget) &&
            !event.currentTarget.matches(':hover')
          ) {
            onPause(group.key, false);
          }
        }}
      >
        <MessageNotificationCard
          group={group}
          transient
          onOpen={() => onOpen(group)}
          onDismiss={() => onDismiss(group.key)}
        />
      </div>
    ))}
  </div>
);
